export const ActionKeys = {
  REQUEST_USER_INFO: "REQUEST_USER_INFO",
  RECEIVE_USER_INFO: "RECEIVE_USER_INFO"
};
